module.exports = __webpack_public_path__ + "static/hex_profile@2x-debe8ad9d4d07ddc65a0f0ef928d33e6.png";